<template>
  <header class="ps-top">
    <div class="wrap ps-top__inner">
      <router-link to="/" class="ps-logo" :aria-label="$t('auth.backHome')">
        <img src="/images/pos.png" alt="PosSmart" class="ps-logo__img" />
        <span class="ps-logo__text">PosSmart</span>
      </router-link>
      <router-link v-if="showBack" :to="backTo" class="ps-top__back">
        <v-icon size="14">fal fa-arrow-left</v-icon>
        {{ backLabel }}
      </router-link>
      <slot v-else />
    </div>
  </header>
</template>

<script>
export default {
  name: "PsTopBar",
  props: {
    backTo: { type: String, default: "/" },
    backLabel: { type: String, default: "" },
    showBack: { type: Boolean, default: true },
  },
};
</script>

<style scoped>
.wrap {
  max-width: 80rem;
  margin: 0 auto;
  padding: 0 1rem;
}
@media (min-width: 640px) {
  .wrap {
    padding: 0 1.5rem;
  }
}
@media (min-width: 1024px) {
  .wrap {
    padding: 0 2rem;
  }
}

.ps-top {
  border-bottom: 1px solid var(--ps-slate-300);
  background: var(--ps-cream);
  flex-shrink: 0;
}

.ps-top__inner {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ps-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: var(--ps-ink);
}

.ps-logo__img {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid #141021;
  box-shadow: var(--ps-shadow-hard);
  object-fit: cover;
  display: block;
}

.ps-logo__text {
  font-weight: 900;
  font-size: 20px;
  letter-spacing: -0.02em;
}

.ps-top__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid #141021;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.875rem;
  color: var(--ps-ink);
  text-decoration: none;
  transition: background-color 0.15s ease;
}
.ps-top__back:hover {
  background: #fff;
}
</style>
